module.exports = __webpack_public_path__ + "static/img/jjfa3.5e17028.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jjfa3.jpg
// module id = Ca1i
// module chunks = 1